import api from "./axiosInstance";

import { baseURL, createHeaders } from "./constants";

const keysPair = async (params) => {
  const { id } = params;
  try {
    return api.get(`${baseURL}/company-api-keys?populate=*&filters[company][id]=${id}`, {
      headers: createHeaders()
    });
  } catch (error) {
    throw error;
  }
};

const deleteKeysPair = async (id) => {
  try {
    return api.delete(`${baseURL}/company-api-keys/${id}`, {
      headers: createHeaders()
    });
  } catch (error) {
    throw error;
  }
};

const getKeyPairById = async (id) => {
  try {
    return api.get(`${baseURL}/company-api-keys/${id}?populate=*`, {
      headers: createHeaders()
    });
  } catch (error) {
    throw error;
  }
};

const editKeyPair = async (id, data) => {
  try {
    return api.put(`${baseURL}/company-api-keys/${id}`, data, {
      headers: createHeaders()
    });
  } catch (error) {
    throw error;
  }
};

const regenerateKeys = async (id) => {
  try {
    return api.post(`${baseURL}/regenerate-keys`, { apiKeyId: id }, {
      headers: createHeaders()
    });
  } catch (error) {
    throw error;
  }
};

export { keysPair, deleteKeysPair, editKeyPair, getKeyPairById, regenerateKeys };